export const quizzes = [
  {
    id: '1',
    category: 'Science: Computers',
    type: 'multiple',
    easy: [
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What does the MP  stand for in MP3?',
        correct_answer: 'Moving Picture',
        incorrect_answers: ['Music Player', 'Multi Pass', 'Micro Point'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What does GHz stand for?',
        correct_answer: 'Gigahertz',
        incorrect_answers: ['Gigahotz', 'Gigahetz', 'Gigahatz'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'The programming language  Swift  was created to replace what other programming language?',
        correct_answer: 'Objective-C',
        incorrect_answers: ['C#', 'Ruby', 'C++'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'HTML is what type of language?',
        correct_answer: 'Markup Language',
        incorrect_answers: [
          'Macro Language',
          'Programming Language',
          'Scripting Language',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What amount of bits commonly equals one byte?',
        correct_answer: '8',
        incorrect_answers: ['1', '2', '64'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'If you were to code software in this language you d only be able to type 0 s and 1 s.',
        correct_answer: 'Binary',
        incorrect_answers: ['JavaScript', 'C++', 'Python'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'The series of the Intel HD graphics generation succeeding that of the 5000 and 6000 series (Broadwell) is called:',
        correct_answer: 'HD Graphics 500',
        incorrect_answers: [
          'HD Graphics 700 ',
          'HD Graphics 600',
          'HD Graphics 7000',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What is the code name for the mobile operating system Android 7.0?',
        correct_answer: 'Nougat',
        incorrect_answers: ['Ice Cream Sandwich', 'Jelly Bean', 'Marshmallow'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'How many values can a single byte represent?',
        correct_answer: '256',
        incorrect_answers: ['8', '1', '1024'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What language does Node.js use?',
        correct_answer: 'JavaScript',
        incorrect_answers: ['Java', 'Java Source', 'Joomla Source Code'],
      },
    ],
    medium: [
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Moore s law originally stated that the number of transistors on a microprocessor chip would double every...',
        correct_answer: 'Year',
        incorrect_answers: ['Four Years', 'Two Years', 'Eight Years'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What does AD stand for in relation to Windows Operating Systems? ',
        correct_answer: 'Active Directory',
        incorrect_answers: [
          'Alternative Drive',
          'Automated Database',
          'Active Department',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'When was the programming language C#  released?',
        correct_answer: '2000',
        incorrect_answers: ['1998', '1999', '2001'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What five letter word is the motto of the IBM Computer company?',
        correct_answer: 'Think',
        incorrect_answers: ['Click', 'Logic', 'Pixel'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'On which computer hardware device is the BIOS chip located?',
        correct_answer: 'Motherboard',
        incorrect_answers: [
          'Hard Disk Drive',
          'Central Processing Unit',
          'Graphics Processing Unit',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'All of the following programs are classified as raster graphics editors EXCEPT:',
        correct_answer: 'Inkscape',
        incorrect_answers: ['Paint.NET', 'GIMP', 'Adobe Photoshop'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Nvidia s headquarters are based in which Silicon Valley city?',
        correct_answer: 'Santa Clara',
        incorrect_answers: ['Palo Alto', 'Cupertino', 'Mountain View'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What did the name of the Tor Anonymity Network orignially stand for?',
        correct_answer: 'The Onion Router',
        incorrect_answers: [
          'The Only Router',
          'The Orange Router',
          'The Ominous Router',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What was the name given to Android 4.3?',
        correct_answer: 'Jelly Bean',
        incorrect_answers: ['Lollipop', 'Nutella', 'Froyo'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these is the name for the failed key escrow device introduced by the National Security Agency in 1993?',
        correct_answer: 'Clipper Chip',
        incorrect_answers: ['Enigma Machine', 'Skipjack', 'Nautilus'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What does the acronym CDN stand for in terms of networking?',
        correct_answer: 'Content Delivery Network',
        incorrect_answers: [
          'Content Distribution Network',
          'Computational Data Network',
          'Compressed Data Network',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which one of these is not an official development name for a Ubuntu release?',
        correct_answer: 'Mystic Mansion',
        incorrect_answers: ['Trusty Tahr', 'Utopic Unicorn', 'Wily Werewolf'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What is the name of the default theme that is installed with Windows XP?',
        correct_answer: 'Luna',
        incorrect_answers: ['Neptune', 'Whistler', 'Bliss'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In the programming language Python , which of these statements would display the string Hello World  correctly?',
        correct_answer: 'print( Hello World )',
        incorrect_answers: [
          'console.log( Hello World )',
          'echo Hello World ',
          'printf( Hello World )',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In programming, the ternary operator is mostly defined with what symbol(s)?',
        correct_answer: '?:',
        incorrect_answers: ['??', 'if then', '?'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'In computing terms, typically what does CLI stand for?',
        correct_answer: 'Command Line Interface',
        incorrect_answers: [
          'Common Language Input',
          'Control Line Interface',
          'Common Language Interface',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What does LCD  stand for?',
        correct_answer: 'Liquid Crystal Display',
        incorrect_answers: [
          'Language Control Design',
          'Last Common Difference',
          'Long Continuous Design',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: '.rs is the top-level domain for what country?',
        correct_answer: 'Serbia',
        incorrect_answers: ['Romania', 'Russia', 'Rwanda'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: '.at is the top-level domain for what country?',
        correct_answer: 'Austria',
        incorrect_answers: ['Argentina', 'Australia', 'Angola'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is known as the brain  of the Computer?',
        correct_answer: 'Central Processing Unit',
        incorrect_answers: [
          'Motherboard',
          'Graphics Processing Unit',
          'Keyboard',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which programming language was developed by Sun Microsystems in 1995?',
        correct_answer: 'Java',
        incorrect_answers: ['Python', 'Solaris OS', 'C++'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'The name of technology company HP stands for what?',
        correct_answer: 'Hewlett-Packard',
        incorrect_answers: [
          'Howard Packmann',
          'Husker-Pollosk',
          'Hellman-Pohl',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In programming, what do you call functions with the same name but different implementations?',
        correct_answer: 'Overloading',
        incorrect_answers: ['Overriding', 'Abstracting', 'Inheriting'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question: 'How many bytes are in a single Kibibyte?',
        correct_answer: '1024',
        incorrect_answers: ['2400', '1000', '1240'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'The teapot often seen in many 3D modeling applications is called what?',
        correct_answer: 'Utah Teapot',
        incorrect_answers: ['Pixar Teapot', '3D Teapot', 'Tennessee Teapot'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'How many bits make up the significand portion of a single precision floating point number?',
        correct_answer: '23',
        incorrect_answers: ['8', '53', '15'],
      },
    ],
    hard: [
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What was the name of the security vulnerability found in Bash in 2014?',
        correct_answer: 'Shellshock',
        incorrect_answers: ['Heartbleed', 'Bashbug', 'Stagefright'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Who is the original author of the realtime physics engine called PhysX?',
        correct_answer: 'NovodeX',
        incorrect_answers: ['Ageia', 'Nvidia', 'AMD'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which of the following is the oldest of these computers by release date?',
        correct_answer: 'TRS-80',
        incorrect_answers: ['Commodore 64', 'ZX Spectrum', 'Apple 3'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the name of the process that sends one qubit of information using two bits of classical information?',
        correct_answer: 'Quantum Teleportation',
        incorrect_answers: [
          'Super Dense Coding',
          'Quantum Entanglement',
          'Quantum Programming',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'America Online (AOL) started out as which of these online service providers?',
        correct_answer: 'Quantum Link',
        incorrect_answers: ['CompuServe', 'Prodigy', 'GEnie'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What internet protocol was documented in RFC 1459?',
        correct_answer: 'IRC',
        incorrect_answers: ['HTTP', 'HTTPS', 'FTP'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Which RAID array type is associated with data mirroring?',
        correct_answer: 'RAID 1',
        incorrect_answers: ['RAID 0', 'RAID 10', 'RAID 5'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What was the first company to use the term Golden Master ?',
        correct_answer: 'Apple',
        incorrect_answers: ['IBM', 'Microsoft', 'Google'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Released in 2001, the first edition of Apple s Mac OS X operating system (version 10.0) was given what animal code name?',
        correct_answer: 'Cheetah',
        incorrect_answers: ['Puma', 'Tiger', 'Leopard'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Dutch computer scientist Mark Overmars is known for creating which game development engine?',
        correct_answer: 'Game Maker',
        incorrect_answers: ['Stencyl', 'Construct', 'Torque 2D'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What major programming language does Unreal Engine 4 use?',
        correct_answer: 'C++',
        incorrect_answers: ['Assembly', 'C#', 'ECMAScript'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question: 'The acronym RIP  stands for which of these?',
        correct_answer: 'Routing Information Protocol',
        incorrect_answers: [
          'Runtime Instance Processes',
          'Regular Interval Processes',
          'Routine Inspection Protocol',
        ],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which of the following computer components can be built using only NAND gates?',
        correct_answer: 'ALU',
        incorrect_answers: ['CPU', 'RAM', 'Register'],
      },
      {
        category: 'Science: Computers',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which kind of algorithm is Ron Rivest not famous for creating?',
        correct_answer: 'Secret sharing scheme',
        incorrect_answers: [
          'Hashing algorithm',
          'Asymmetric encryption',
          'Stream cipher',
        ],
      },
    ],
  },
  {
    id: '2',
    category: 'General Knowledge',
    type: 'multiple',
    easy: [
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the first book of the Old Testament?',
        correct_answer: 'Genesis',
        incorrect_answers: ['Exodus', 'Leviticus', 'Numbers'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'In the video-game franchise Kingdom Hearts, the main protagonist, carries a weapon with what shape?',
        correct_answer: 'Key',
        incorrect_answers: ['Sword', 'Pen', 'Cellphone'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Area 51 is located in which US state?',
        correct_answer: 'Nevada',
        incorrect_answers: ['Arizona', 'New Mexico', 'Utah'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which sign of the zodiac is represented by the Crab?',
        correct_answer: 'Cancer',
        incorrect_answers: ['Libra', 'Virgo', 'Sagittarius'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What does the  S  stand for in the abbreviation SIM, as in SIM card? ',
        correct_answer: 'Subscriber',
        incorrect_answers: ['Single', 'Secure', 'Solid'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is dabbing?',
        correct_answer: 'A dance',
        incorrect_answers: ['A medical procedure', 'A sport', 'A language'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which one of the following rhythm games was made by Harmonix?',
        correct_answer: 'Rock Band',
        incorrect_answers: [
          'Meat Beat Mania',
          'Guitar Hero Live',
          'Dance Dance Revolution',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What type of animal was Harambe, who was shot after a child fell into it s enclosure at the Cincinnati Zoo?',
        correct_answer: 'Gorilla',
        incorrect_answers: ['Tiger', 'Panda', 'Crocodile'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Five dollars is worth how many nickles?',
        correct_answer: '100',
        incorrect_answers: ['50', '25', '69'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who is depicted on the US hundred dollar bill?',
        correct_answer: 'Benjamin Franklin',
        incorrect_answers: [
          'George Washington',
          'Abraham Lincoln',
          'Thomas Jefferson',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What do the letters of the fast food chain KFC stand for?',
        correct_answer: 'Kentucky Fried Chicken',
        incorrect_answers: [
          'Kentucky Fresh Cheese',
          'Kibbled Freaky Cow',
          'Kiwi Food Cut',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'How tall is the Burj Khalifa?',
        correct_answer: '2,722 ft',
        incorrect_answers: ['2,717 ft', '2,546 ft', '3,024 ft'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What company developed the vocaloid Hatsune Miku?',
        correct_answer: 'Crypton Future Media',
        incorrect_answers: ['Sega', 'Sony', 'Yamaha Corporation'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which candy is NOT made by Mars?',
        correct_answer: 'Almond Joy',
        incorrect_answers: ['M&amp;M s', 'Twix', 'Snickers'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is Cynophobia the fear of?',
        correct_answer: 'Dogs',
        incorrect_answers: ['Birds', 'Flying', 'Germs'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Terry Gilliam was an animator that worked with which British comedy group?',
        correct_answer: 'Monty Python',
        incorrect_answers: [
          'The Goodies&lrm;',
          'The League of Gentlemen&lrm;',
          'The Penny Dreadfuls',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What is the name of NASA&rsquo;s most famous space telescope?',
        correct_answer: 'Hubble Space Telescope',
        incorrect_answers: ['Big Eye', 'Death Star', 'Millenium Falcon'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who is the youngest person to recieve a Nobel Prize?',
        correct_answer: 'Malala Yousafzai',
        incorrect_answers: [
          'Lawrence Bragg',
          'Werner Heisenberg',
          'Yasser Arafat',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which of the following is not an Ivy League University?',
        correct_answer: 'Stanford',
        incorrect_answers: [
          'University of Pennsylvania',
          'Harvard',
          'Princeton',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which country has the union jack in its flag?',
        correct_answer: 'New Zealand',
        incorrect_answers: ['South Africa', 'Canada', 'Hong Kong'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who invented the first ever chocolate bar, in 1847?',
        correct_answer: 'Joseph Fry',
        incorrect_answers: ['Andrew Johnson', 'John Cadbury', 'John Tyler'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'easy',
        question: 'In aerodynamics, which force pushes an object upwards?',
        correct_answer: 'Lift',
        incorrect_answers: ['Drag', 'Weight', 'Thrust'],
      },
    ],
    medium: [
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What does the G mean in G-Man?',
        correct_answer: 'Government',
        incorrect_answers: ['Going', 'Ghost', 'Geronimo'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which language is NOT Indo-European?',
        correct_answer: 'Hungarian',
        incorrect_answers: ['Russian', 'Greek', 'Latvian'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of the following Ivy League universities has its official motto in Hebrew as well as in Latin?',
        correct_answer: 'Yale University',
        incorrect_answers: [
          'Princeton University',
          'Harvard University',
          'Columbia University',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is a dakimakura?',
        correct_answer: 'A body pillow',
        incorrect_answers: [
          'A Chinese meal, essentially composed of fish',
          'A yoga posture',
          'A word used to describe two people who truly love each other',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the unit of currency in Laos?',
        correct_answer: 'Kip',
        incorrect_answers: ['Ruble', 'Konra', 'Dollar'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the German word for spoon?',
        correct_answer: 'L&ouml;ffel',
        incorrect_answers: ['Gabel', 'Messer', 'Essst&auml;bchen'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What is the name of the popular animatronic singing fish prop, singing such hits such as Don t Worry, Be Happy?',
        correct_answer: 'Big Mouth Billy Bass',
        incorrect_answers: ['Big Billy Bass', 'Singing Fish', 'Sardeen'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'According to the United States  CDC, one in how many Americans die annually due to smoking?',
        correct_answer: 'Five',
        incorrect_answers: ['Twenty', 'Ten', 'One hundred'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who is the founder of The Lego Group?',
        correct_answer: 'Ole Kirk Christiansen',
        incorrect_answers: [
          ' Jens Niels Christiansen',
          'Kirstine Christiansen',
          ' Gerhardt Kirk Christiansen',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What character was once considered to be the 27th letter of the alphabet?',
        correct_answer: 'Ampersand',
        incorrect_answers: ['Interrobang', 'Tilde', 'Pilcrow'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'The new One World Trade Center in Manhattan, New York City was designed by which architect? ',
        correct_answer: 'David Childs',
        incorrect_answers: ['Bjarke Ingels', 'Michael Arad', 'Fumihiko Maki'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of the General Mills Corporation s monster cereals was the last to be released in the 1970 s?',
        correct_answer: 'Fruit Brute',
        incorrect_answers: ['Count Chocula', 'Franken Berry', 'Boo-Berry'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'When did the website Facebook launch?',
        correct_answer: '2004',
        incorrect_answers: ['2005', '2003', '2006'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Computer manufacturer Compaq was acquired for $25 billion dollars in 2002 by which company?',
        correct_answer: 'Hewlett-Packard',
        incorrect_answers: ['Toshiba', 'Asus', 'Dell'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What was the original name of the search engine Google?',
        correct_answer: 'BackRub',
        incorrect_answers: ['CatMassage', 'SearchPro', 'Netscape Navigator'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'medium',
        question: 'A statue of Charles Darwin sits in what London museum?',
        correct_answer: 'Natural History Museum',
        incorrect_answers: ['Tate', 'British Museum', 'Science Museum'],
      },
    ],
    hard: [
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Sciophobia is the fear of what?',
        correct_answer: 'Shadows',
        incorrect_answers: ['Eating', 'Bright lights', 'Transportation'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'De Eemhof, Port Zelande and Het Heijderbos are holiday villas owned by what company?',
        correct_answer: 'Center Parcs',
        incorrect_answers: ['Yelloh Village', 'Keycamp', 'Villa Plus'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'According to Fair Works Australia, how long do you have to work to get Long Service Leave?',
        correct_answer: '7 years',
        incorrect_answers: ['2 years', '8 years', '6 months'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Virtual reality company Oculus VR lost which of it s co-founders in a freak car accident in 2013?',
        correct_answer: 'Andrew Scott Reisse',
        incorrect_answers: ['Nate Mitchell', 'Jack McCauley', 'Palmer Luckey'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Named after the mallow flower, mauve is a shade of what?',
        correct_answer: 'Purple',
        incorrect_answers: ['Red', 'Brown', 'Pink'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'How many notes are there on a standard grand piano?',
        correct_answer: '88',
        incorrect_answers: ['98', '108', '78'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'The word astasia means which of the following?',
        correct_answer: 'The inability to stand up',
        incorrect_answers: [
          'The inability to make decisions',
          'The inability to concentrate on anything',
          'A feverish desire to rip one s clothes off',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'The word aprosexia means which of the following?',
        correct_answer: 'The inability to concentrate on anything',
        incorrect_answers: [
          'The inability to make decisions',
          'A feverish desire to rip one s clothes off',
          'The inability to stand up',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What is the full title of the Prime Minister of the UK?',
        correct_answer: 'First Lord of the Treasury',
        incorrect_answers: [
          'Duke of Cambridge',
          'Her Majesty s Loyal Opposition',
          'Manager of the Crown Estate',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'The Fields Medal, one of the most sought after awards in mathematics, is awarded every how many years?',
        correct_answer: '4',
        incorrect_answers: ['3', '5', '6'],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Frank Lloyd Wright was the architect behind what famous building?',
        correct_answer: 'The Guggenheim',
        incorrect_answers: [
          'Villa Savoye',
          'Sydney Opera House',
          'The Space Needle',
        ],
      },
      {
        category: 'General Knowledge',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What fast food chain has the most locations globally? ',
        correct_answer: 'Subway',
        incorrect_answers: ['Starbucks', 'McDonalds', 'KFC'],
      },
    ],
  },
  {
    id: '3',
    category: 'Entertainment: Music',
    type: 'multiple',
    easy: [
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which artist released the 2012 single Harlem Shake, which was used in numerous YouTube videos in 2013?',
        correct_answer: 'Baauer',
        incorrect_answers: ['RL Grime', 'NGHTMRE', 'Flosstradamus'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What was the subject of the 2014 song CoCo by American rapper O. T. Genasis?',
        correct_answer: 'Cocaine',
        incorrect_answers: [
          'Conan O Brien',
          'Cobalt(II) carbonate',
          'Coconut cream pie',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'The K in K-Pop stands for which word?',
        correct_answer: 'Korean',
        incorrect_answers: ['Kenyan', 'Kazakhstan', 'Kuwaiti'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What collaborative album was released by Kanye West and Jay-Z in 2011?',
        correct_answer: 'Watch the Throne',
        incorrect_answers: [
          'Distant Relatives',
          'What a Time to be Alive',
          'Unfinished Business',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What album did The Lumineers release in 2016?',
        correct_answer: 'Cleopatra',
        incorrect_answers: ['Winter', 'The Lumineers', 'Tracks From The Attic'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What was Daft Punk s first studio album?',
        correct_answer: 'Homework',
        incorrect_answers: [
          'Discovery',
          'Random Access Memories',
          'Human After All',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which classical composer wrote the Moonlight Sonata?',
        correct_answer: 'Ludvig Van Beethoven',
        incorrect_answers: [
          'Chief Keef',
          'Wolfgang Amadeus Mozart',
          'Johannes Brahms',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which former boy-band star released hit solo single Angels in 1997?',
        correct_answer: 'Robbie Williams',
        incorrect_answers: ['Justin Timberlake', 'Harry Styles', 'Gary Barlow'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What 1970 s American ballad referred to the 1959 plane crash as the the day the music died?',
        correct_answer: 'American Pie',
        incorrect_answers: [
          'Kentucky Rain',
          'I Will Always Love You',
          'Rock  n  Roll Suicide',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'The British Invasion was a cultural phenomenon in music where British boy bands became popular in the USA in what decade?',
        correct_answer: '60 s',
        incorrect_answers: ['50 s', '40 s', '30 s'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who was Kung Fu Fighting in 1974?',
        correct_answer: 'Carl Douglas',
        incorrect_answers: ['The Bee Gees', 'Heatwave', 'Kool &amp; the Gang'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who is the lead singer of Arctic Monkeys?',
        correct_answer: 'Alex Turner',
        incorrect_answers: ['Jamie Cook', 'Matt Helders', 'Nick O Malley'],
      },
    ],
    medium: [
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What French artist/band is known for playing on the midi instrument Launchpad?',
        correct_answer: 'Madeon',
        incorrect_answers: ['Daft Punk ', 'Disclosure', 'David Guetta'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which Beatle led the way across the zebra crossing on the Abbey Road album cover?',
        correct_answer: 'John',
        incorrect_answers: ['Paul', 'George', 'Ringo'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which country is singer Kyary Pamyu Pamyu from?',
        correct_answer: 'Japan',
        incorrect_answers: ['South Korea', 'China', 'Vietnam'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In which city did American rap producer DJ Khaled originate from?',
        correct_answer: 'Miami',
        incorrect_answers: ['New York', 'Detroit', 'Atlanta'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these is NOT the name of an album released by American rapper Viper?',
        correct_answer: 'The Life of Pablo',
        incorrect_answers: [
          'Kill Urself My Man',
          'You ll Cowards Don t Even Smoke Crack',
          'Yo Wife Handcuffin  Me',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who is the lead singer of Silverchair?',
        correct_answer: 'Daniel Johns',
        incorrect_answers: ['Ben Gillies', 'Chris Joannou', 'George Costanza'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which one of these Pink Floyd albums were also a movie?',
        correct_answer: 'The Wall',
        incorrect_answers: [
          'The Dark Side of the Moon',
          'Wish You Were Here',
          'Animals',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who is the frontman of Muse?',
        correct_answer: 'Matt Bellamy',
        incorrect_answers: ['Dominic Howard', 'Thom Yorke', 'Jonny Greenwood'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'How many members are in the Japanese rock band SCANDAL?',
        correct_answer: '4',
        incorrect_answers: ['5', '2', '18'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which rapper had an album that went double platinum with no features?',
        correct_answer: 'J. Cole',
        incorrect_answers: ['Kendrick Lamar', 'Drake', 'Big Sean'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these songs is not on the untitled album by Led Zeppelin?',
        correct_answer: 'Celebration Day',
        incorrect_answers: ['Stairway to Heaven', 'Black Dog', 'Rock and Roll'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which band released the album Sonic Highways in 2014?',
        correct_answer: 'Foo Fighters',
        incorrect_answers: ['Coldplay', 'Nickelback', 'The Flaming Lips'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who was the lead singer and frontman of rock band R.E.M?',
        correct_answer: 'Michael Stipe',
        incorrect_answers: ['Chris Martin', 'Thom Yorke', 'George Michael'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In which year was the Megadeth album Peace Sells... but Who s Buying? released?',
        correct_answer: '1986',
        incorrect_answers: ['1979', '1987', '1983'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which novelty band was best known for their UK chart hits Combine Harvester and I Am a Cider Drinker in 1976?',
        correct_answer: 'The Wurzels',
        incorrect_answers: [
          'Goldie Lookin Chain',
          'Bonzo Dog Doo-Dah Band',
          'The Firm',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What country did Shirley Bassey originate from?',
        correct_answer: 'Wales',
        incorrect_answers: ['America', 'England', 'Canada'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which artist curated the official soundtrack for The Hunger Games: Mockingjay - Part 1?',
        correct_answer: 'Lorde',
        incorrect_answers: ['Kanye West', 'Tove Lo', 'Charli XCX'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the opening track on Lorde s Pure Heroine?',
        correct_answer: 'Tennis Court',
        incorrect_answers: ['Team', 'Royals', '400 Lux'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What album did Gorillaz release in 2017?',
        correct_answer: 'Humanz',
        incorrect_answers: ['Plastic Beach', 'The Fall', 'Demon Days'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'On the cover of  Abbey Road,  which of the Beatles is not wearing shoes?',
        correct_answer: 'Paul McCartney',
        incorrect_answers: ['Ringo Starr', 'John Lennon', 'George Harrison'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'How many studio albums have the heavy metal band,  Metallica  released in the period between 1983 and 2016?',
        correct_answer: '10',
        incorrect_answers: ['7', '9', '12'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these is not a member of the virtual band Gorillaz?',
        correct_answer: 'Phi Cypher',
        incorrect_answers: ['Murdoc Niccals', 'Noodle', 'Russel Hobbs'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What was Raekwon the Chefs debut solo album?',
        correct_answer: 'Only Built 4 Cuban Linx',
        incorrect_answers: [
          'Shaolin vs Wu-Tang',
          'The Wild',
          'The Lex Diamond Story',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'The Proclaimers - I m Gonna Be (500 Miles) reached what position on the US Hot 100 Charts in 1993?',
        correct_answer: '3rd',
        incorrect_answers: ['8th', '1st', '5th'],
      },
    ],
    hard: [
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Who was the original drummer for The Beatles?',
        correct_answer: 'Tommy Moore',
        incorrect_answers: ['Ringo Starr', 'Stuart Sutcliffe', 'Pete Best'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Who was not in the band The Smiths?',
        correct_answer: 'Martin Chambers',
        incorrect_answers: ['Morrissey', 'Andy Rourke', 'Mike Joyce'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which Death Grips album is the only one to feature a band member?',
        correct_answer: 'No Love Deep Web',
        incorrect_answers: [
          'Bottomless Pit',
          'The Money Store',
          'The Powers That B',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the English title of the vaporwave track リサフランク420 / 現代のコンピュー by Macintosh Plus (Vektroid)?',
        correct_answer: 'Lisa Frank 420 / Modern Computing',
        incorrect_answers: [
          'Smoke Weed 420 / Everyday',
          'Make Your Move 420 / My Mind',
          'It s All In Your Head 420 / Understand',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'In Kendrick Lamar s 2012 album, Good Kid, M.A.A.D City, the album s story takes place in which city?',
        correct_answer: 'Compton',
        incorrect_answers: ['Detroit', 'New York', 'Baltimore'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Which of Michael Jackson s albums sold the most copies?',
        correct_answer: 'Thriller',
        incorrect_answers: ['Dangerous', 'Bad', 'Off the Wall'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What was the name of the hip hop group Kanye West was a member of in the late 90s?',
        correct_answer: 'The Go-Getters',
        incorrect_answers: [
          'The Jumpers',
          'The Kickstarters',
          'The Beat-Busters',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Electronic artists Boys Noize and Skrillex have collaborated and released tracks under what name?',
        correct_answer: 'Dog Blood',
        incorrect_answers: ['Jack &Uuml;', 'What So Not', 'Noisia'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Bj&ouml;rk s Unison contains a sample of which Oval song?',
        correct_answer: 'Aero Deck',
        incorrect_answers: ['Textuell', 'Panorama', 'Do While'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What was the name of the rock band that Nobuo Uematsu formed that played songs from various Final Fantasy games?',
        correct_answer: 'The Black Mages',
        incorrect_answers: [
          'The Final Fantasies',
          'The Espers',
          'The Rock Summoners',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What is the official name of Prince s backing band?',
        correct_answer: 'The Revolution',
        incorrect_answers: ['The Paupers', 'The Wailers', 'The Heartbreakers'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Pamina and Papageno are characters in what Mozart opera?',
        correct_answer: 'The Magic Flute',
        incorrect_answers: [
          'The Marriage of Figaro',
          'The Impresario',
          'The Goose of Cairo',
        ],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Where was Nicki Minaj born?',
        correct_answer: 'Trinidad and Tobago',
        incorrect_answers: ['Haiti', 'Saint Lucia', 'Grenada'],
      },
      {
        category: 'Entertainment: Music',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Panic! At the Disco s sixth album Pray For The Wicked was released on which date?',
        correct_answer: 'June 22, 2018',
        incorrect_answers: [
          'May 9, 2018',
          'March 13, 2018',
          'February 21, 2018',
        ],
      },
    ],
  },
  {
    id: '4',
    category: 'Geography',
    type: 'multiple',
    easy: [
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which city is the capital of the United States of America?',
        correct_answer: 'Washington D.C',
        incorrect_answers: ['Seattle', 'Albany', 'Los Angeles'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What country is the second largest in the world by area?',
        correct_answer: 'Canada',
        incorrect_answers: ['Russia', 'China', 'United States of America'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'All of the following are classified as Finno-Ugric languages EXCEPT:',
        correct_answer: 'Samoyedic',
        incorrect_answers: ['Hungarian', 'Finnish', 'Estonian'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which nation claims ownership of Antarctica?',
        correct_answer: 'No one, but there are claims.',
        incorrect_answers: [
          'United States of America',
          'United Nations',
          'Australia',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the official language of Costa Rica?',
        correct_answer: 'Spanish',
        incorrect_answers: ['English', 'Portuguese', 'Creole'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What country has a horizontal bicolor red and white flag?',
        correct_answer: 'Monaco',
        incorrect_answers: ['Bahrain', 'Malta', 'Liechenstein'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the nickname for the US state Delaware?',
        correct_answer: 'The First State',
        incorrect_answers: [
          'The Fiftieth State',
          'The Second State',
          'The Sixteenth State',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'The Space Needle is located in which city?',
        correct_answer: 'Seattle',
        incorrect_answers: ['Los Angles', 'Toronto', 'Vancouver'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Harvard University is located in which city?',
        correct_answer: 'Cambridge',
        incorrect_answers: ['Providence', 'New York', 'Washington D.C.'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which country is the home of the largest Japanese population outside of Japan?',
        correct_answer: 'Brazil',
        incorrect_answers: ['China', 'Russia', 'The United States'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'How many stars are featured on New Zealand s flag?',
        correct_answer: '4',
        incorrect_answers: ['5', '2', '0'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the name of New Zealand s indigenous people?',
        correct_answer: 'Maori',
        incorrect_answers: ['Vikings', 'Polynesians', 'Samoans'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the capital of Spain?',
        correct_answer: 'Madrid',
        incorrect_answers: ['Barcelona', 'Sevilla', 'Toledo'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is the largest country in the world?',
        correct_answer: 'Russia',
        incorrect_answers: ['Canada', 'China', 'United States'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What is Laos?',
        correct_answer: 'Country',
        incorrect_answers: ['Region', 'River', 'City'],
      },
    ],
    medium: [
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What European country is not a part of the EU?',
        correct_answer: 'Norway',
        incorrect_answers: ['Lithuania', 'Ireland', 'Czechia'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'On a London Underground map, what colour is the Circle Line?',
        correct_answer: 'Yellow',
        incorrect_answers: ['Red', 'Blue', 'Green'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which country inside the United Kingdom does NOT appear on its flag, the Union Jack?',
        correct_answer: 'Wales',
        incorrect_answers: ['Scotland', 'Ireland', 'Isle of Wight'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the largest non-continental island in the world?',
        correct_answer: 'Greenland',
        incorrect_answers: ['New Guinea', 'Borneo', 'Madagascar'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of the following language families is the most controversial amongst modern linguists?',
        correct_answer: 'Altaic',
        incorrect_answers: ['Sino-Tibetan', 'Dravidian', 'Indo-European'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'The land of Gotland is located in which European country?',
        correct_answer: 'Sweden',
        incorrect_answers: ['Denmark', 'Norway', 'Germany'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'On which continent is the country of Angola located?',
        correct_answer: 'Africa',
        incorrect_answers: ['South America', 'Europe', 'Asia'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'How many countries are larger than Australia?',
        correct_answer: '5',
        incorrect_answers: ['4', '3', '6'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which German city is located on the River Isar?',
        correct_answer: 'Munich',
        incorrect_answers: ['Berlin', 'Hamburg', 'Dortmund'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Where are the Nazca Lines located?',
        correct_answer: 'Peru',
        incorrect_answers: ['Brazil', 'Colombia', 'Ecuador'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which Canadian province has Charlottetown as its capital?',
        correct_answer: 'Prince Edward Island',
        incorrect_answers: ['Saskachewan', 'Northwest Terrirories', 'Ontario'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'The land mass of modern day Turkey is called what?',
        correct_answer: 'Anatolia',
        incorrect_answers: ['Ismuth of Ottoma', 'Ottoma', 'Ismuth of Anatolia'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What city  has the busiest airport in the world?',
        correct_answer: 'Atlanta, Georgia USA',
        incorrect_answers: [
          'London, England',
          'Chicago,Illinois ISA',
          'Tokyo,Japan',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What was the most populous city in the Americas in 2015?',
        correct_answer: 'S&atilde;o Paulo',
        incorrect_answers: ['New York', 'Mexico City', 'Los Angeles'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Where is the  Sonoran Desert  located?',
        correct_answer: 'North America',
        incorrect_answers: ['South America', 'Asia', 'Africa'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which of these country s capitals starts with the letter B?',
        correct_answer: 'Lebanon',
        incorrect_answers: ['Jordan', 'Kuwait', 'Qatar'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which of the following is NOT a capital city?',
        correct_answer: 'Sydney',
        incorrect_answers: ['Cairo', 'Moscow', 'Beijing'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Frankenmuth, a US city nicknamed  Little Bavaria , is located in what state?',
        correct_answer: 'Michigan',
        incorrect_answers: ['Pennsylvania', 'Kentucky', 'Virginia'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Lake Titicaca is located between which two nations?',
        correct_answer: 'Peru and Bolivia',
        incorrect_answers: [
          'Kenya and Uganda',
          'Mexico and the United States',
          'India and Bangladesh',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which of these Japanese islands is the largest by area?',
        correct_answer: 'Shikoku',
        incorrect_answers: ['Iki', 'Odaiba', 'Okinawa'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'The Pyrenees mountains are located on the border of which two countries?',
        correct_answer: 'France and Spain',
        incorrect_answers: [
          'Italy and Switzerland',
          'Norway and Sweden',
          'Russia and Ukraine',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What city is the Terracotta Army located in?',
        correct_answer: 'Xi an',
        incorrect_answers: ['Beijing', 'Shanghai', 'Hong Kong'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these American cities has fewer than 1,000,000 people?',
        correct_answer: 'San Francisco, California',
        incorrect_answers: [
          'Phoenix, Arizona',
          'San Antonio, Texas',
          'Philadelphia, Pennsylvania',
        ],
      },
    ],
    hard: [
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the largest city and commercial capital of Sri Lanka?',
        correct_answer: 'Colombo',
        incorrect_answers: ['Moratuwa', 'Negombo', 'Kandy'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which of these countries is NOT a part of the Asian continent?',
        correct_answer: 'Suriname',
        incorrect_answers: ['Georgia', 'Russia', 'Singapore'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which of these island countries is located in the Caribbean?',
        correct_answer: 'Barbados',
        incorrect_answers: ['Fiji', 'Maldives', 'Seychelles'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the name of one of the Neo-Aramaic languages spoken by the Jewish population from Northwestern Iraq?',
        correct_answer: 'Lishana Deni',
        incorrect_answers: [
          'Hulaul&aacute;',
          'Lishan Didan',
          'Chaldean Neo-Aramaic',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What year is on the flag of the US state Wisconsin?',
        correct_answer: '1848',
        incorrect_answers: ['1634', '1783', '1901'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Llanfair&shy;pwllgwyngyll&shy;gogery&shy;chwyrn&shy;drobwll&shy;llan&shy;tysilio&shy;gogo&shy;goch is located on which Welsh island?',
        correct_answer: 'Anglesey',
        incorrect_answers: ['Barry', 'Bardsey', 'Caldey'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Fucking is a village in which country?',
        correct_answer: 'Austria',
        incorrect_answers: ['Germany', 'Switzerland', 'Czech Republic'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What city is known as the Rose Capital of the World?',
        correct_answer: 'Tyler, Texas',
        incorrect_answers: [
          'San Diego, California',
          'Miami, Florida',
          'Anaheim, California',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the name of rocky region that spans most of eastern Canada?',
        correct_answer: 'Canadian Shield',
        incorrect_answers: [
          'Rocky Mountains',
          'Appalachian Mountains',
          'Himalayas',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What is Canada s largest island?',
        correct_answer: 'Baffin Island',
        incorrect_answers: [
          'Prince Edward Island',
          'Vancouver Island',
          'Newfoundland',
        ],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'What is the capital of Mauritius?',
        correct_answer: 'Port Louis',
        incorrect_answers: ['Port Moresby', 'Port Vila', 'Port-au-Prince'],
      },
      {
        category: 'Geography',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Which country is the Taedong River in?',
        correct_answer: 'North Korea',
        incorrect_answers: ['South Korea', 'Japan', 'China'],
      },
    ],
  },
  {
    id: '5',
    category: 'Sports',
    type: 'multiple',
    easy: [
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which English football club has the nickname  The Foxes ?',
        correct_answer: 'Leicester City',
        incorrect_answers: [
          'Northampton Town',
          'Bradford City',
          'West Bromwich Albion',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'In what sport is a  shuttlecock  used?',
        correct_answer: 'Badminton',
        incorrect_answers: ['Table Tennis', 'Rugby', 'Cricket'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which team won the 2015-16 English Premier League?',
        correct_answer: 'Leicester City',
        incorrect_answers: ['Liverpool', 'Cheslea', 'Manchester United'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'The Rio 2016 Summer Olympics held it s closing ceremony on what date?',
        correct_answer: 'August 21',
        incorrect_answers: ['August 23', 'August 19', 'August 17'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which country has hosted the 2018 FIFA World Cup?',
        correct_answer: 'Russia',
        incorrect_answers: ['Germany', 'United States', 'Saudi Arabia'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'What was the final score of the Germany vs. Brazil 2014 FIFA World Cup match?',
        correct_answer: '7 - 1',
        incorrect_answers: ['0 - 1', '3 - 4', '16 - 0'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'What team won the 2016 MLS Cup?',
        correct_answer: 'Seattle Sounders',
        incorrect_answers: ['Colorado Rapids', 'Toronto FC', 'Montreal Impact'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'This Canadian television sportscaster is known for his  Hockey Night in Canada  role, a commentary show during hockey games.',
        correct_answer: 'Don Cherry',
        incorrect_answers: ['Don McKellar', 'Don Taylor ', 'Donald Sutherland'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'When was the first official international game played?',
        correct_answer: '1872',
        incorrect_answers: ['1880', '1863', '1865'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which boxer was banned for taking a bite out of Evander Holyfield s ear in 1997?',
        correct_answer: 'Mike Tyson',
        incorrect_answers: [
          'Roy Jones Jr.',
          'Evander Holyfield',
          'Lennox Lewis',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Who is often called  the Maestro  in the men s tennis circuit?',
        correct_answer: 'Roger Federer',
        incorrect_answers: ['Bill Tilden', 'Boris Becker', 'Pete Sampras'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which African American is in part responsible for integrating  Major League baseball?',
        correct_answer: 'Jackie Robinson',
        incorrect_answers: ['Curt Flood', 'Roy Campanella', 'Satchell Paige'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which player holds the NHL record of 2,857 points?',
        correct_answer: 'Wayne Gretzky',
        incorrect_answers: ['Mario Lemieux ', 'Sidney Crosby', 'Gordie Howe'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          ' Stadium of Light  is the home stadium for which soccer team?',
        correct_answer: 'Sunderland FC',
        incorrect_answers: [
          'Barcelona FC',
          'Paris Saints-Germain',
          'Manchester United',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'Which year did Jenson Button won his first ever Formula One World Drivers  Championship?',
        correct_answer: '2009',
        incorrect_answers: ['2010', '2007', '2006'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Who won the 2017 Formula One World Drivers  Championship?',
        correct_answer: 'Lewis Hamilton',
        incorrect_answers: [
          'Sebastian Vettel',
          'Nico Rosberg',
          'Max Verstappen',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question:
          'In the 2014 FIFA World Cup, what was the final score in the match Brazil - Germany?',
        correct_answer: '1-7',
        incorrect_answers: ['1-5', '1-6', '2-6'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'easy',
        question: 'Which two teams played in Super Bowl XLII?',
        correct_answer: 'The New York Giants &amp; The New England Patriots',
        incorrect_answers: [
          'The Green Bay Packers &amp; The Pittsburgh Steelers',
          'The Philadelphia Eagles &amp; The New England Patriots',
          'The Seattle Seahawks &amp; The Denver Broncos',
        ],
      },
    ],
    medium: [
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'At which bridge does the annual Oxford and Cambridge boat race start?',
        correct_answer: 'Putney',
        incorrect_answers: ['Hammersmith', 'Vauxhall ', 'Battersea'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which German sportswear company s logo is the  Formstripe ?',
        correct_answer: 'Puma',
        incorrect_answers: ['Nike', 'Adidas', 'Reebok'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What is the nickname of Northampton town s rugby union club?',
        correct_answer: 'Saints',
        incorrect_answers: ['Harlequins', 'Saracens', 'Wasps'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which Formula One driver was nicknamed  The Professor ?',
        correct_answer: 'Alain Prost',
        incorrect_answers: ['Ayrton Senna', 'Niki Lauda', 'Emerson Fittipaldi'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'How many scoring zones are there on a conventional dart board?',
        correct_answer: '82',
        incorrect_answers: ['62', '42', '102'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which nation hosted the FIFA World Cup in 2006?',
        correct_answer: 'Germany',
        incorrect_answers: ['United Kingdom', 'Brazil', 'South Africa'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which team was the 2014-2015 NBA Champions?',
        correct_answer: 'Golden State Warriors',
        incorrect_answers: [
          'Cleveland Cavaliers',
          'Houston Rockets',
          'Atlanta Hawks',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which soccer team won the Copa Am&eacute;rica 2015 Championship ?',
        correct_answer: 'Chile',
        incorrect_answers: ['Argentina', 'Brazil', 'Paraguay'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which soccer team won the Copa Am&eacute;rica Centenario 2016?',
        correct_answer: 'Chile',
        incorrect_answers: ['Argentina', 'Brazil', 'Colombia'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In 2016, who won the Formula 1 World Constructor s Championship for the third time in a row?',
        correct_answer: 'Mercedes-AMG Petronas',
        incorrect_answers: [
          'Scuderia Ferrari',
          'McLaren Honda',
          'Red Bull Racing Renault',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the oldest team in the NFL?',
        correct_answer: 'Arizona Cardinals',
        incorrect_answers: [
          'Chicago Bears',
          'Green Bay Packers',
          'New York Giants',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What is the oldest team in Major League Baseball?',
        correct_answer: 'Atlanta Braves',
        incorrect_answers: [
          'Chicago Cubs',
          'Cincinnati Reds',
          'St. Louis Cardinals',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'In Formula 1, the Virtual Safety Car was introduced following the fatal crash of which driver?',
        correct_answer: 'Jules Bianchi',
        incorrect_answers: [
          'Ayrton Senna',
          'Ronald Ratzenberger',
          'Gilles Villeneuve',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Who won the 2015 College Football Playoff (CFP) National Championship? ',
        correct_answer: 'Ohio State Buckeyes',
        incorrect_answers: [
          'Alabama Crimson Tide',
          'Clemson Tigers',
          'Wisconsin Badgers',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of the following pitchers was named National League Rookie of the Year for the 2013 season?',
        correct_answer: 'Jose Fernandez',
        incorrect_answers: ['Jacob deGrom', 'Shelby Miller', 'Matt Harvey'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Which car manufacturer won the 2017 24 Hours of Le Mans?',
        correct_answer: 'Porsche',
        incorrect_answers: ['Toyota', 'Audi', 'Chevrolet'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who is Manchester United s top premier league goal scorer?',
        correct_answer: 'Wayne Rooney',
        incorrect_answers: [
          'Sir Bobby Charlton',
          'Ryan Giggs',
          'David Beckham',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who was the topscorer for England national football team?',
        correct_answer: 'Wayne Rooney',
        incorrect_answers: ['David Beckham', 'Steven Gerrard', 'Michael Owen'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'What is the name of the AHL affiliate of the Toronto Maple Leafs?',
        correct_answer: 'Toronto Marlies',
        incorrect_answers: [
          'Toronto Rock',
          'Toronto Argonauts',
          'Toronto Wolfpack',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'What country hosted the 2014 Winter Olympics?',
        correct_answer: 'Russia',
        incorrect_answers: ['Canada', 'United States', 'Germany'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question:
          'Which of these countries  national teams qualified for the 2018 FIFA World Cup in Russia?',
        correct_answer: 'Tunisia',
        incorrect_answers: ['United States of America', 'Italy', 'Netherlands'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'medium',
        question: 'Who was the top scorer of the 2014 FIFA World Cup?',
        correct_answer: 'James Rodr&iacute;guez',
        incorrect_answers: ['Thomas M&uuml;ller', 'Lionel Messi', 'Neymar'],
      },
    ],
    hard: [
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'With which doubles partner did John McEnroe have most success?',
        correct_answer: 'Peter Fleming',
        incorrect_answers: ['Mark Woodforde', 'Michael Stich', 'Mary Carillo'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which Italian footballer told Neuer where he s putting his shot and dragging it wide, during the match Italy-Germany, UEFA EURO 2016?',
        correct_answer: 'Pelle',
        incorrect_answers: ['Insigne', 'Barzagli', 'Giaccherini'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which male player won the gold medal of table tennis singles in 2016 Olympics Games?',
        correct_answer: 'Ma Long (China)',
        incorrect_answers: [
          'Zhang Jike (China)',
          'Jun Mizutani (Japan)',
          'Vladimir Samsonov (Belarus)',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which female player won the gold medal of table tennis singles in 2016 Olympics Games?',
        correct_answer: 'DING Ning (China)',
        incorrect_answers: [
          'LI Xiaoxia (China)',
          'Ai FUKUHARA (Japan)',
          'Song KIM (North Korea)',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What is the full name of the footballer  Cristiano Ronaldo ?',
        correct_answer: 'Cristiano Ronaldo dos Santos Aveiro',
        incorrect_answers: [
          'Cristiano Ronaldo los Santos Diego',
          'Cristiano Armando Diego Ronaldo',
          'Cristiano Luis Armando Ronaldo',
        ],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'What team did England beat in the semi-final stage to win in the 1966 World Cup final?',
        correct_answer: 'Portugal',
        incorrect_answers: ['West Germany', 'Soviet Union', 'Brazil'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which city features all of their professional sports teams  jersey s with the same color scheme?',
        correct_answer: 'Pittsburgh',
        incorrect_answers: ['New York', 'Seattle', 'Tampa Bay'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question:
          'Which player  kung-fu kicked  a Crystal Palace fan in January 1995?',
        correct_answer: 'Eric Cantona',
        incorrect_answers: ['David Seamen', 'Ashley Cole', 'Mark Hughes'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question: 'The Mazda 787B won the 24 Hours of Le Mans in what year?',
        correct_answer: '1991',
        incorrect_answers: ['1990', '2000', '1987'],
      },
      {
        category: 'Sports',
        type: 'multiple',
        difficulty: 'hard',
        question: 'Which English football team is nicknamed  The Tigers ?',
        correct_answer: 'Hull City',
        incorrect_answers: ['Cardiff City', 'Bristol City', 'Manchester City'],
      },
    ],
  },
];
